import _ from 'lodash';
import { MyXLSX2 } from '@/utils/xlsxExport2';
import moment from 'moment';

export default {
    methods: {
        getInvoiceTypeText(typ) {
            if (typ === -1) return '折讓';
            if (typ === 1) return 'INVOICE';
            if (typ === 2) return '二聯式發票';
            if (typ === 3) return '三聯式發票';
            if (typ === 4) return '核銷';
            return '';
        },
        getTaxAmount(item, isDiscount) {
            if (item.typ === undefined) return item.tax;
            if (isDiscount) return item.foO_DIS_AMT_TAX;
            return item.amT_TAX;
        },
        getPeriodText(year, month) {
            const PERIOD_OBJECT = _.find(this.periodList, { year, value: month });
            return PERIOD_OBJECT ? `${PERIOD_OBJECT.year - 1911}年 ${PERIOD_OBJECT.period}` : '尚未申報';
        },
        async onExportExcel() {
            try {
                const wb = MyXLSX2.createBook();
                this.isLoading = true;

                if (this.queryParams.QueryType === 1) {
                    const undeclaredSheet = await this.onExportInvoiceUndeclared();
                    const declaredTableData = await this.onExportInvoiceDeclared();
                    const zeroTaxTableData = await this.onExportInvoiceOthers(3);
                    const noNeedDeclareTableData = await this.onExportInvoiceOthers(4);

                    MyXLSX2.bookAppendSheet(wb, undeclaredSheet, '未申報');
                    MyXLSX2.bookAppendSheet(wb, declaredTableData, '已申報');
                    MyXLSX2.bookAppendSheet(wb, zeroTaxTableData, '零稅率');
                    MyXLSX2.bookAppendSheet(wb, noNeedDeclareTableData, '免申報');
                    MyXLSX2.download(wb, `${this.getExportFileName('銷項')}`);
                } else {
                    const undeclaredSheet = await this.onExportPaymentUndeclared();
                    const declaredTableData = await this.onExportPaymentDeclared();
                    const notDeclareTableData = await this.onExportPaymentOthers(3);
                    const invalidTableData = await this.onExportPaymentOthers(4);

                    MyXLSX2.bookAppendSheet(wb, undeclaredSheet, '未申報');
                    MyXLSX2.bookAppendSheet(wb, declaredTableData, '已申報');
                    MyXLSX2.bookAppendSheet(wb, notDeclareTableData, '不申報扣抵');
                    MyXLSX2.bookAppendSheet(wb, invalidTableData, '不能申報的其他單據');
                    MyXLSX2.download(wb, `${this.getExportFileName('進項')}`);
                }
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },
        async getExportData(params) {
            const PageSize = 1000;
            let PageNum = 1;
            const url = 'AccountingSummaryPage/Query401';

            // 指定要匯出的單據類型
            let dataTypeName = '';
            switch (params.QueryType) {
            case 2:
                dataTypeName = 'payment';
                break;
            case 3:
                dataTypeName = 'paymentInvoice';
                break;
            default:
                dataTypeName = 'invoice';
            }

            const { data } = await this.$api({
                url,
                method: 'GET',
                params: {
                    ...params,
                    QueryType: params.QueryType === 2 || params.QueryType === 3 ? 2 : 1,
                    PageNum: 1,
                    PageSize,
                },
            });

            // 足夠的PageSize
            if (PageSize > data[`${dataTypeName}ResultTotalNum`]) {
                return data[`${dataTypeName}Result`];
            }

            const currentList = [...data[`${dataTypeName}Result`]];
            for (let i = 0; i < Math.ceil(data[`${dataTypeName}ResultTotalNum`] / PageSize) - 1; i += 1) {
                PageNum += 1;
                // eslint-disable-next-line no-await-in-loop
                const resp = await this.$api({
                    url,
                    method: 'GET',
                    params: {
                        ...params,
                        QueryType: params.QueryType === 2 || params.QueryType === 3 ? 2 : 1,
                        PageNum,
                        PageSize,
                    },
                });
                currentList.push(...resp.data[`${dataTypeName}Result`]);
            }

            return currentList;
        },
        async onExportInvoiceUndeclared() {
            const DETAILS = await this.getExportData({ ...this.queryParams, TaxDeclareStatus: 1 });

            const title = '營業稅申報-銷項';

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '單據日期', align: 'left' },
                { text: '單據類型', width: 20, align: 'center' },
                { text: '單據號碼', align: 'center' },
                { text: '作廢', width: 10, align: 'center' },
                { text: '格式代號', align: 'right', number: true },
                { text: '銷售額(未稅)', align: 'right', number: true },
                { text: '稅額', align: 'right', number: true },
                { text: '買方公司', align: 'left' },
                { text: '買方統編', align: 'center' },
                { text: '來源發票', align: 'center' },
                {
                    text: '退回折讓申報期別',
                    width: 20,
                    align: 'right',
                    number: true,
                },
                {
                    text: '退回折讓/作廢金額',
                    width: 20,
                    align: 'right',
                    number: true,
                },
                {
                    text: '退回折讓/作廢稅額',
                    width: 20,
                    align: 'right',
                    number: true,
                },
                { text: '退回折讓/作廢日期', width: 20, align: 'center' },
            ];
            // 內容資料
            const bodyRows = [];
            DETAILS.forEach((item, i) => {
                const row = [
                    i + 1,
                    moment(item.foO_DAT).format('YYYY-MM-DD'),
                    this.getInvoiceTypeText(item.typ, item.foO_CNL),
                    item.foo,
                    item.typ > 0 && item.foO_CNL ? '作廢' : '',
                    item.code || '',
                    item.foO_CNL ? 0 : this.getExportAmt(item),
                    item.foO_CNL ? 0 : this.getExportTaxAmt(item),
                    item.companyName,
                    item.bsn,
                    item.ioo || '',
                    item.typ > 0 && item.foO_DIS_PREFIX_YER ? `${this.getPeriodText(item.foO_DIS_PREFIX_YER, item.foO_DIS_PREFIX_MONTH)}` : '',
                    item.foO_CNL ? this.getExportAmt(item) : this.getExportDiscountAmt(item),
                    item.foO_CNL ? this.getExportTaxAmt(item) : this.getExportDiscountTaxAmt(item),
                    item.typ > 0 && (item.foO_DIS_DAT || item.foO_CNL) ? moment(item.foO_DIS_DAT).format('YYYY-MM-DD') : '',
                ];
                bodyRows.push(row);
            });
            // 總計列
            const totalAmt = _.chain(bodyRows)
                .filter((o) => !o[2].includes('作廢'))
                .sumBy(5)
                .value();
            const totalTax = _.chain(bodyRows)
                .filter((o) => !o[2].includes('作廢'))
                .sumBy(6)
                .value();
            const totalDiscount = _.sumBy(bodyRows, (o) => Number(o[12]));
            const totalDiscountTax = _.sumBy(bodyRows, (o) => Number(o[13]));

            bodyRows.push(['', '總計', '', '', '', '', totalAmt, totalTax, '', '', '', '', totalDiscount, totalDiscountTax, '']);

            // 日期資訊
            const headRows = this.getXlsxHeaderRow();

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },
        async onExportInvoiceDeclared() {
            const DETAILS = await this.getExportData({ ...this.queryParams, TaxDeclareStatus: 2 });

            const title = '營業稅申報-銷項';

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '單據日期', align: 'left' },
                { text: '單據類型', width: 20, align: 'center' },
                { text: '申報期別', align: 'center' },
                { text: '單據號碼', align: 'center' },
                { text: '作廢', width: 10, align: 'center' },
                { text: '格式代號', align: 'right', number: true },
                { text: '銷售額(未稅)', align: 'right', number: true },
                { text: '稅額', align: 'right', number: true },
                { text: '買方公司', align: 'left' },
                { text: '買方統編', align: 'center' },
                { text: '來源發票', align: 'center' },
                {
                    text: '退回折讓申報期別',
                    width: 20,
                    align: 'right',
                    number: true,
                },
                {
                    text: '退回折讓/作廢金額',
                    width: 20,
                    align: 'right',
                    number: true,
                },
                {
                    text: '退回折讓/作廢稅額',
                    width: 20,
                    align: 'right',
                    number: true,
                },
                { text: '退回折讓/作廢日期', width: 20, align: 'center' },
            ];
            // 內容資料
            const bodyRows = [];
            DETAILS.forEach((item, i) => {
                const row = [
                    i + 1,
                    moment(item.foO_DAT).format('YYYY-MM-DD'),
                    this.getInvoiceTypeText(item.typ, item.foO_CNL),
                    item.typ > 0 ? `${this.getPeriodText(item.prefiX_YER, item.prefiX_MONTH)}` : `${this.getPeriodText(item.foO_DIS_PREFIX_YER, item.foO_DIS_PREFIX_MONTH)}`,
                    item.foo,
                    item.typ > 0 && item.foO_CNL ? '作廢' : '',
                    item.code || '',
                    item.foO_CNL ? 0 : this.getExportAmt(item),
                    item.foO_CNL ? 0 : this.getExportTaxAmt(item),
                    item.companyName,
                    item.bsn,
                    item.ioo || '',
                    item.typ > 0 && item.foO_DIS_PREFIX_YER ? `${this.getPeriodText(item.foO_DIS_PREFIX_YER, item.foO_DIS_PREFIX_MONTH)}` : '',
                    item.foO_CNL ? this.getExportAmt(item) : this.getExportDiscountAmt(item),
                    item.foO_CNL ? this.getExportTaxAmt(item) : this.getExportDiscountTaxAmt(item),
                    item.typ > 0 && (item.foO_DIS_DAT || item.foO_CNL) ? moment(item.foO_DIS_DAT).format('YYYY-MM-DD') : '',
                ];
                bodyRows.push(row);
            });
            // 總計列
            const totalAmt = _.chain(bodyRows)
                .filter((o) => !o[2].includes('作廢'))
                .sumBy(6)
                .value();
            const totalTax = _.chain(bodyRows)
                .filter((o) => !o[2].includes('作廢'))
                .sumBy(7)
                .value();
            const totalDiscount = _.sumBy(bodyRows, (o) => Number(o[13]));
            const totalDiscountTax = _.sumBy(bodyRows, (o) => Number(o[14]));

            bodyRows.push(['', '總計', '', '', '', '', '', totalAmt, totalTax, '', '', '', '', totalDiscount, totalDiscountTax, '']);

            // 日期資訊
            const headRows = this.getXlsxHeaderRow();

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },
        async onExportInvoiceOthers(TaxDeclareStatus) {
            const DETAILS = await this.getExportData({ ...this.queryParams, TaxDeclareStatus });

            const title = '營業稅申報-銷項';

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '單據日期', align: 'left' },
                { text: '單據類型', width: 20, align: 'center' },
                { text: '單據號碼', align: 'center' },
                { text: '作廢', width: 10, align: 'center' },
                { text: '銷售額(未稅)', align: 'right', number: true },
                { text: '稅額', align: 'right', number: true },
                { text: '買方公司', align: 'left' },
                { text: '買方統編', align: 'center' },
                { text: '來源發票', align: 'center' },
                {
                    text: '退回折讓/作廢金額',
                    width: 20,
                    align: 'right',
                    number: true,
                },
                {
                    text: '退回折讓/作廢稅額',
                    width: 20,
                    align: 'right',
                    number: true,
                },
                { text: '退回折讓/作廢日期', width: 20, align: 'center' },
            ];
            // 內容資料
            const bodyRows = [];
            DETAILS.forEach((item, i) => {
                const row = [
                    i + 1,
                    moment(item.foO_DAT).format('YYYY-MM-DD'),
                    this.getInvoiceTypeText(item.typ, item.foO_CNL),
                    item.foo || '',
                    item.typ > 0 && item.foO_CNL ? '作廢' : '',
                    item.foO_CNL ? 0 : this.getExportAmt(item),
                    item.foO_CNL ? 0 : this.getExportTaxAmt(item),
                    item.companyName,
                    item.bsn,
                    item.ioo || '',
                    item.foO_CNL ? this.getExportAmt(item) : this.getExportDiscountAmt(item),
                    item.foO_CNL ? this.getExportTaxAmt(item) : this.getExportDiscountTaxAmt(item),
                    item.typ > 0 && (item.foO_DIS_DAT || item.foO_CNL) ? moment(item.foO_DIS_DAT).format('YYYY-MM-DD') : '',
                ];
                bodyRows.push(row);
            });
            // 總計列
            const totalAmt = _.chain(bodyRows)
                .filter((o) => !o[2].includes('作廢'))
                .sumBy(5)
                .value();
            const totalTax = _.chain(bodyRows)
                .filter((o) => !o[2].includes('作廢'))
                .sumBy(6)
                .value();
            const totalDiscount = _.sumBy(bodyRows, (o) => Number(o[10]));
            const totalDiscountTax = _.sumBy(bodyRows, (o) => Number(o[11]));

            bodyRows.push(['', '總計', '', '', '', totalAmt, totalTax, '', '', '', totalDiscount, totalDiscountTax, '']);

            // 日期資訊
            const headRows = this.getXlsxHeaderRow();

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },

        async onExportPaymentUndeclared() {
            const DETAILS = await this.getExportData({ ...this.queryParams, TaxDeclareStatus: 1 });

            const title = '營業稅申報-進項';

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '單據日期', align: 'left' },
                { text: '單據類型', width: 10, align: 'center' },
                { text: '單據號碼', align: 'center' },
                { text: '格式代號', align: 'right', number: true },
                { text: '收支項目', align: 'center' },
                { text: '銷售額(未稅)', align: 'right', number: true },
                { text: '稅額', align: 'right', number: true },
                { text: '賣方公司', align: 'left' },
                { text: '賣方統編', align: 'center' },
                { text: '來源請款單', align: 'center' },
            ];
            // 內容資料
            const bodyRows = [];
            DETAILS.forEach((item, i) => {
                const row = [
                    i + 1,
                    moment(item.foO_DAT).format('YYYY-MM-DD'),
                    item.filE_TYP_NAM,
                    item.foo,
                    item.code || '',
                    item.iteM_NAM || '',
                    item.amt - item.tax,
                    item.tax,
                    item.companyName || '',
                    item.bsn || '',
                    item.payoo || '',
                ];
                bodyRows.push(row);
            });
            // 總計列
            const totalAmt = _.sumBy(bodyRows, 6);
            const totalTax = _.sumBy(bodyRows, 7);

            bodyRows.push(['', '總計', '', '', '', '', totalAmt, totalTax, '', '', '']);

            // 日期資訊
            const headRows = this.getXlsxHeaderRow();

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },
        async onExportPaymentDeclared() {
            const DETAILS = await this.getExportData({ ...this.queryParams, TaxDeclareStatus: 2 });

            const title = '營業稅申報-進項';

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '單據日期', align: 'left' },
                { text: '單據類型', width: 10, align: 'center' },
                { text: '申報期別', align: 'center' },
                { text: '單據號碼', align: 'center' },
                { text: '格式代號', align: 'right', number: true },
                { text: '收支項目', align: 'center' },
                { text: '銷售額(未稅)', align: 'right', number: true },
                { text: '稅額', align: 'right', number: true },
                { text: '賣方公司', align: 'left' },
                { text: '賣方統編', align: 'center' },
                { text: '來源請款單', align: 'center' },
            ];
            // 內容資料
            const bodyRows = [];
            DETAILS.forEach((item, i) => {
                const row = [
                    i + 1,
                    moment(item.foO_DAT).format('YYYY-MM-DD'),
                    item.filE_TYP_NAM,
                    `${this.getPeriodText(item.prefiX_YER, item.prefiX_MONTH)}`,
                    item.foo,
                    item.code || '',
                    item.iteM_NAM || '',
                    item.amt - item.tax,
                    item.tax,
                    item.companyName || '',
                    item.bsn || '',
                    item.payoo || '',
                ];
                bodyRows.push(row);
            });
            // 總計列
            const totalAmt = _.sumBy(bodyRows, 7);
            const totalTax = _.sumBy(bodyRows, 8);

            bodyRows.push(['', '總計', '', '', '', '', '', totalAmt, totalTax, '', '', '']);

            // 日期資訊
            const headRows = this.getXlsxHeaderRow();

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },
        async onExportPaymentOthers(TaxDeclareStatus) {
            const DETAILS = await this.getExportData({ ...this.queryParams, TaxDeclareStatus });
            const title = '營業稅申報-進項';

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '單據日期', align: 'left' },
                { text: '單據類型', width: 10, align: 'center' },
                { text: '單據號碼', align: 'center' },
                { text: '收支項目', align: 'center' },
                { text: '銷售額(未稅)', align: 'right', number: true },
                { text: '稅額', align: 'right', number: true },
                { text: '賣方公司', align: 'left' },
                { text: '賣方統編', align: 'center' },
                { text: '來源請款單', align: 'center' },
            ];
            // 內容資料
            const bodyRows = [];
            DETAILS.forEach((item, i) => {
                const row = [
                    i + 1,
                    moment(item.foO_DAT).format('YYYY-MM-DD'),
                    item.filE_TYP_NAM,
                    item.foo,
                    item.iteM_NAM || '',
                    item.amt - item.tax,
                    item.tax,
                    item.companyName || '',
                    item.bsn || '',
                    item.payoo || '',
                ];
                bodyRows.push(row);
            });
            // 總計列
            const totalAmt = _.sumBy(bodyRows, 5);
            const totalTax = _.sumBy(bodyRows, 6);

            bodyRows.push(['', '總計', '', '', '', totalAmt, totalTax, '', '', '']);

            // 日期資訊
            const headRows = this.getXlsxHeaderRow();

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },

        getXlsxHeaderRow() {
            const sd = moment(Number(this.queryParams.StartDate)).format('YYYY-MM-DD');
            const ed = moment(Number(this.queryParams.EndDate)).format('YYYY-MM-DD');
            const cd = moment().format('YYYY-MM-DD');
            return [
                { label: '查詢區間', value: `${sd} 至 ${ed}` },
                { label: '製表日期', value: cd },
            ];
        },
        getExportFileName(suffix) {
            const sd = moment(Number(this.queryParams.StartDate)).format('YYYY-MM-DD');
            const ed = moment(Number(this.queryParams.EndDate)).format('YYYY-MM-DD');
            return `營業稅申報-${suffix}(${sd}_${ed})`;
        },

        getExportAmt(item) {
            return item.typ > 0
                ? Math.round(item.amt * (item.rat || 1)) - Math.round(this.getTaxAmount(item) * (item.rat || 1))
                : Math.round(item.foO_DIS_AMT * (item.rat || 1)) - Math.round(this.getTaxAmount(item, true) * (item.rat || 1));
        },
        getExportTaxAmt(item) {
            return item.typ > 0 ? Math.round(this.getTaxAmount(item) * (item.rat || 1)) : Math.round(this.getTaxAmount(item, true) * (item.rat || 1));
        },
        getExportDiscountAmt(item) {
            return item.typ > 0 && item.foO_DIS_AMT > 0 ? Math.round(item.foO_DIS_AMT * (item.rat || 1) - item.foO_DIS_AMT_TAX * (item.rat || 1)) : '';
        },
        getExportDiscountTaxAmt(item) {
            return item.typ > 0 && item.foO_DIS_AMT > 0 ? Math.round(item.foO_DIS_AMT_TAX * (item.rat || 1)) : '';
        },
    },
};
